import type { ParentTaskType } from "@repo/api";

export const isDropinTask = (
  parentTaskType?: ParentTaskType,
  subTaskType?: string
) => {
  return parentTaskType === "appointment" && subTaskType === "dropIn";
};
